import "../mock"
import axios from "axios";
import ViewUI from 'view-design'

export const API = window.WinPageData.common_api;
export const iview = ViewUI;
export const ERR_TEXT = "出了点问题，请稍后重试";


export const request = ({ url, params, type = "get" }) => {

  return new Promise((resolve, reject) => {
    let axiosConfig = {
      url: url,
      method: type
    };

    if (type === "get" || type === "GET") {
      axiosConfig.params = params;
    } else {
      // axiosConfig.data = JSON.stringify(params);
      axiosConfig.data = params;
    }
    return axios(axiosConfig)
      .then(res => {
        if (!res.stat && res.stat != 0) {
          res = res.data
        }
        if (res.stat == 1) {
          resolve(res);
          return;
        } else if (res.stat == 2) {
          iview.Message.warning({
            content: res.msg || ERR_TEXT,
            onClose: () => {
              window.location.href = res.data.url;
            }
          });
        } else {
          reject(res);
        }
      })
      .catch(res => {
        reject(res);
        iview.Message.warning(res.msg || ERR_TEXT);
      });
  });
};



// WEBPACK FOOTER //
// ./pc/index/api/common.js